import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './style.scss';

export default class Checkbox extends React.Component {

	static propTypes = {
		checked: PropTypes.bool,
		value: PropTypes.bool, // для работы внутри Field/Column
		disabled: PropTypes.bool,
		onChange: PropTypes.func,
		label: PropTypes.any,
		className: PropTypes.string,
	};

	static defaultProps = {
		checked: false,
		disabled: false,
		size: 20,
		className: '',
	};

	onChange = () => {
		const checked = this.props.value !== undefined ? this.props.value : this.props.checked;
		if (this.props.onChange) this.props.onChange(!checked);
	};

	render () {
		const { className, disabled, label } = this.props;

		const checked = this.props.value !== undefined ? this.props.value : this.props.checked;

		return <span className={'ui-checkbox ' + className + (disabled ? ' disabled' : '')}
			      onClick={() => this.onChange()}>
			<span className="ui-checkbox-toggle">
				{checked && <FontAwesomeIcon icon={faCheck}/>}
			</span>
			{label}
		</span>;
	}

}
